import React, { Component } from "react";
import { Redirect } from "react-router";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBIcon
} from "mdbreact";
import axios from "axios";
import API_URL from "./../config";
import { rutaInicial } from "./../permisos";
import logo1 from "./LogoRemuneraciones.png";
import fondo2 from "./Fondo2.jpg";
import fondo3 from "./fondo3.png";

const generateCaptcha = () => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let captcha = "";
  for (let i = 0; i < 6; i++) {
    captcha += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return captcha;
};

class Login extends Component {
  state = {
    contacts: [],
    username: "",
    clave: "",
    capcha: generateCaptcha(),
    capchaIngresado: "",
      errorCaptcha: "",
      errorLogin: "",
    usuarioEnviado: "",
    showPassword: false,
    // Cambio obligatorio de contraseña
    mostrarCambioPass: false,
    cambioLogin: "",
    cambioToken: "",
    nuevaPass: "",
    confirmarPass: "",
    showNueva: false,
    showConfirmar: false,
    errorCambio: "",
    cargandoCambio: false
  };

  onChange(e) {
    const value = e.target.name === 'capchaIngresado' ? e.target.value.toUpperCase() : e.target.value;
    this.setState({ [e.target.name]: value, errorLogin: "" });
  }

  onSubmit = (e) => {
    e.preventDefault();

    this.setState({ errorLogin: "", errorCaptcha: "" });

    if (!this.state.username.trim() || !this.state.clave.trim()) {
      this.setState({ errorLogin: "Ingrese su usuario y contraseña" });
      return;
    }
    if (!this.state.capchaIngresado.trim()) {
      this.setState({ errorCaptcha: "Ingrese el codigo de verificacion" });
      return;
    }
    if (this.state.capchaIngresado !== this.state.capcha) {
      this.setState({ capchaIngresado: "", capcha: generateCaptcha(), errorCaptcha: "Codigo de verificacion incorrecto" });
      return;
    }

    axios
      .post(`${API_URL}/verificarpassword/`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          usuario: this.state.username,
          clave: this.state.clave
        })
      })
      .then((response) => {
        if (response.data && response.data.length > 0) {
          // Verificar si usuario está deshabilitado
          if (response.data[0].deshabilitado === "1") {
            this.setState({ errorLogin: "Su cuenta se encuentra deshabilitada. Coordine con la jefatura para su habilitación.", capcha: generateCaptcha(), capchaIngresado: "" });
            return;
          }
          // Verificar si debe cambiar contraseña.
          // 11/08/2026 - se guarda tambien el token: el endpoint de cambio de
          // clave ahora exige sesion valida y solo deja cambiar la propia, asi
          // que hay que enviarselo aunque todavia no se haya entrado.
          if (response.data[0].cambiarPass === "1") {
            this.setState({
              mostrarCambioPass: true,
              cambioLogin: response.data[0].trabajador,
              cambioToken: response.data[0].autorizacion,
              errorLogin: ""
            });
            return;
          }
          this.setState({ contacts: response.data, errorLogin: "" });
        } else {
          this.setState({ errorLogin: "Usuario o contraseña incorrectos", capcha: generateCaptcha(), capchaIngresado: "" });
        }
      })
      .catch(() => {
        this.setState({ errorLogin: "Error de conexion. Intente nuevamente", capcha: generateCaptcha(), capchaIngresado: "" });
      });


  };

  refreshCaptcha = () => {
    this.setState({ capcha: generateCaptcha() });
  };

  handleCambioPass = (e) => {
    e.preventDefault();
    var nueva = this.state.nuevaPass;
    var confirmar = this.state.confirmarPass;
    if (!nueva || !confirmar) { this.setState({ errorCambio: 'Complete ambos campos' }); return; }
    if (nueva !== confirmar) { this.setState({ errorCambio: 'Las contraseñas no coinciden' }); return; }
    if (nueva.length < 8) { this.setState({ errorCambio: 'Mínimo 8 caracteres' }); return; }
    if (!/[a-zA-Z]/.test(nueva)) { this.setState({ errorCambio: 'Debe contener al menos una letra' }); return; }
    if (!/[0-9]/.test(nueva)) { this.setState({ errorCambio: 'Debe contener al menos un número' }); return; }

    this.setState({ cargandoCambio: true, errorCambio: '' });
    axios.post(API_URL + '/cambiarpassusuario/', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        login: this.state.cambioLogin,
        pass_nuevo: nueva,
        autorizacion: this.state.cambioToken
      })
    })
    .then(function(response) {
      if (response.data && response.data.length > 0 && response.data[0].resultado === 'OK') {
        this.setState({
          mostrarCambioPass: false, cargandoCambio: false, nuevaPass: '', confirmarPass: '',
          username: this.state.cambioLogin, clave: '', cambioLogin: '', cambioToken: '',
          errorLogin: '', capcha: generateCaptcha(), capchaIngresado: ''
        });
        alert('Contraseña actualizada correctamente. Ingrese con su nueva contraseña.');
      } else {
        var msgCambio = response.data && response.data[0] && response.data[0].mensaje
          ? response.data[0].mensaje : 'Error al cambiar contraseña';
        this.setState({ errorCambio: msgCambio, cargandoCambio: false });
      }
    }.bind(this))
    .catch(function() { this.setState({ errorCambio: 'Error de conexión', cargandoCambio: false }); }.bind(this));
  };

  render() {
    if (this.state.contacts.length > 0) {
      sessionStorage.setItem('datos', JSON.stringify(this.state.contacts));
      // 11/08/2026 - el destino sale de los modulos que concede el rol, no de
      // una cadena "ADMIN"/"OPERADOR" fija. Ver src/permisos.js.
      const destino = rutaInicial(this.state.contacts);
      return (
        <Redirect
          push={false}
          to={{
            pathname: destino,
            state: { datos: this.state.contacts }
          }}
        />
      );
    }

    const captchaColors = ["#c0392b", "#2980b9", "#27ae60", "#8e44ad", "#d35400", "#16a085"];

    // Modal de cambio obligatorio de contraseña
    if (this.state.mostrarCambioPass) {
      var passValida = this.state.nuevaPass.length >= 8 && /[a-zA-Z]/.test(this.state.nuevaPass) && /[0-9]/.test(this.state.nuevaPass);
      var coinciden = this.state.nuevaPass && this.state.nuevaPass === this.state.confirmarPass;
      var formListo = passValida && coinciden;
      return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(135deg, #7A1622, #5C1019)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <MDBCard style={{ maxWidth: '450px', width: '90%', borderRadius: '16px', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
            <MDBCardBody className="px-4 py-4">
              <div className="text-center mb-3">
                <div style={{ width: '70px', height: '70px', borderRadius: '50%', background: '#fff3e0', margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <MDBIcon icon="key" style={{ color: '#F57C00', fontSize: '1.8rem' }} />
                </div>
                <h5 className="font-weight-bold" style={{ color: '#7A1622' }}>Cambio de Contraseña Obligatorio</h5>
                <p style={{ color: '#666', fontSize: '0.88rem', margin: '0' }}>
                  Por seguridad, debe crear una contraseña personal para el usuario <strong style={{ color: '#1565C0' }}>{this.state.cambioLogin}</strong>
                </p>
              </div>
              <hr />
              {this.state.errorCambio && (
                <div style={{ background: '#fdecea', border: '1px solid #f5c6cb', borderRadius: '8px', padding: '10px 14px', marginBottom: '12px' }}>
                  <span style={{ color: '#c0392b', fontWeight: '600', fontSize: '0.85rem' }}>
                    <MDBIcon icon="exclamation-triangle" className="mr-2" />{this.state.errorCambio}
                  </span>
                </div>
              )}
              <form onSubmit={this.handleCambioPass}>
                <div style={{ position: 'relative' }}>
                  <MDBInput label="Nueva contraseña" icon="lock" group
                    value={this.state.nuevaPass}
                    onChange={function(e) { this.setState({ nuevaPass: e.target.value, errorCambio: '' }); }.bind(this)}
                    name="nuevaPass" type={this.state.showNueva ? 'text' : 'password'} />
                  <MDBIcon icon={this.state.showNueva ? 'eye-slash' : 'eye'}
                    onClick={function() { this.setState({ showNueva: !this.state.showNueva }); }.bind(this)}
                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#999' }} />
                </div>
                <div style={{ position: 'relative' }}>
                  <MDBInput label="Confirmar contraseña" icon="lock" group
                    value={this.state.confirmarPass}
                    onChange={function(e) { this.setState({ confirmarPass: e.target.value, errorCambio: '' }); }.bind(this)}
                    name="confirmarPass" type={this.state.showConfirmar ? 'text' : 'password'} />
                  <MDBIcon icon={this.state.showConfirmar ? 'eye-slash' : 'eye'}
                    onClick={function() { this.setState({ showConfirmar: !this.state.showConfirmar }); }.bind(this)}
                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#999' }} />
                </div>
                {this.state.nuevaPass.length > 0 && (
                  <div style={{ background: '#f8f9fa', borderRadius: '8px', padding: '10px 14px', marginBottom: '14px', border: '1px solid #e0e0e0' }}>
                    <p style={{ margin: '0 0 6px', fontSize: '0.82rem', fontWeight: '600', color: '#333' }}>Requisitos:</p>
                    {[
                      { ok: this.state.nuevaPass.length >= 8, text: 'Mínimo 8 caracteres' },
                      { ok: /[a-zA-Z]/.test(this.state.nuevaPass), text: 'Al menos una letra' },
                      { ok: /[0-9]/.test(this.state.nuevaPass), text: 'Al menos un número' },
                      { ok: this.state.confirmarPass && this.state.nuevaPass === this.state.confirmarPass, text: 'Las contraseñas coinciden' }
                    ].map(function(req, i) {
                      return (
                        <p key={i} style={{ margin: '2px 0', fontSize: '0.8rem' }}>
                          <MDBIcon icon={req.ok ? 'check-circle' : 'times-circle'} className="mr-2"
                            style={{ color: req.ok ? '#27ae60' : '#c0392b' }} />
                          <span style={{ color: req.ok ? '#27ae60' : '#666' }}>{req.text}</span>
                        </p>
                      );
                    })}
                  </div>
                )}
                <MDBBtn type="submit" disabled={!formListo || this.state.cargandoCambio}
                  style={{ backgroundColor: formListo ? '#7A1622' : '#999', borderRadius: '20px' }} className="btn-block">
                  {this.state.cargandoCambio ? (
                    <span><MDBIcon icon="spinner" spin className="mr-2" />Guardando...</span>
                  ) : (
                    <span><MDBIcon icon="save" className="mr-2" />Guardar Nueva Contraseña</span>
                  )}
                </MDBBtn>
              </form>
            </MDBCardBody>
          </MDBCard>
        </div>
      );
    }

    return (
      <div style={{ position: "relative", minHeight: "calc(100vh - 4rem)" }}>
        {/* Fondo izquierdo */}
        <div className="d-none d-md-block" style={{
          position: "fixed",
          top: "4rem",
          left: 0,
          width: "25%",
          height: "calc(100vh - 4rem)",
          backgroundImage: `url(${fondo3})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.15
        }} />

        {/* Fondo derecho */}
        <div className="d-none d-md-block" style={{
          position: "fixed",
          top: "4rem",
          right: 0,
          width: "25%",
          height: "calc(100vh - 4rem)",
          backgroundImage: `url(${fondo2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.5
        }} />

        <MDBContainer fluid className="pt-4" style={{ position: "relative", zIndex: 1 }}>
          <MDBRow className="align-items-center" style={{ minHeight: "calc(100vh - 6rem)" }}>
            <MDBCol md="3" lg="3" className="d-none d-md-block" style={{ paddingLeft: "40px" }}>
              <h4 className="font-weight-bold mb-3" style={{ color: "#7A1622" }}>
                <MDBIcon icon="building" className="mr-2" />
                Bienvenido(a)
              </h4>
              <p className="text-muted" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                Sistema de gestión de procesos en la Sub Unidad de Remuneraciones de la UNSAAC.
              </p>

              <h6 className="font-weight-bold mt-4 mb-3" style={{ color: "#333" }}>
                ¿Qué puede hacer en este sistema?
              </h6>

              <div className="mb-3 d-flex align-items-start">
                <MDBIcon icon="file-invoice-dollar" className="mr-3 mt-1" style={{ color: "#7A1622", fontSize: "1.1rem" }} />
                <div>
                  <strong style={{ color: "#333" }}>Boletas de Pago</strong>
                  <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>Consulte y descargue sus boletas de pago de los últimos 6 periodos.</p>
                </div>
              </div>

              <div className="mb-3 d-flex align-items-start">
                <MDBIcon icon="file-upload" className="mr-3 mt-1" style={{ color: "#7A1622", fontSize: "1.1rem" }} />
                <div>
                  <strong style={{ color: "#333" }}>Declaraciones Juradas</strong>
                  <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>Presente su Declaración Jurada de forma digital, correspondiente a: Bono por Escolaridad, Aguinaldo por Fiestas Patrias y Aguinaldo por Navidad. <strong>Solo para personal docente.</strong></p>
                </div>
              </div>

              <div className="mb-3 d-flex align-items-start">
                <MDBIcon icon="user-cog" className="mr-3 mt-1" style={{ color: "#7A1622", fontSize: "1.1rem" }} />
                <div>
                  <strong style={{ color: "#333" }}>Gestión de Cuenta</strong>
                  <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>Administre su contraseña de acceso (creación y modificación).</p>
                </div>
              </div>

              <hr />

              <h6 className="font-weight-bold mb-3" style={{ color: "#333" }}>
                <MDBIcon icon="headset" className="mr-2" style={{ color: "#7A1622" }} />
                Contacto
              </h6>
              <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                <MDBIcon icon="envelope" className="mr-2" style={{ color: "#7A1622" }} />
                remuneraciones@unsaac.edu.pe
              </p>
            </MDBCol>

            <MDBCol md="4" lg="4" className="d-flex justify-content-center" style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", maxWidth: "420px" }}>
            <MDBCard>
              <MDBCardBody className="px-4 py-4">
                <div className="text-center mb-4">
                  <p className="text-muted mb-2" style={{ fontSize: "0.9rem" }}>
                    Universidad Nacional de San Antonio Abad del Cusco
                  </p>
                  <img
                    src={logo1}
                    alt="Logo Remuneraciones"
                    style={{ width: "130px", height: "130px", objectFit: "contain", borderRadius: "50%" }}
                  />
                  <h6 className="mt-2 font-weight-bold" style={{ color: "#7A1622" }}>
                    Sub Unidad de Remuneraciones
                  </h6>
                  <h4 className="font-weight-bold" style={{ color: "#7A1622", fontSize: "1.5rem" }}>
                    Iniciar Sesión
                  </h4>
                </div>

                <hr />

                <form onSubmit={this.onSubmit}>
                    {this.state.errorLogin && (
                      <div style={{ background: '#fdecea', border: '2px solid #e74c3c', borderRadius: '8px', padding: '10px 14px', marginBottom: '15px' }}>
                        <span style={{ color: '#c0392b', fontWeight: '600', fontSize: '0.85rem', display: 'flex', alignItems: 'center' }}>
                          <i className="fas fa-times-circle mr-2" style={{ fontSize: '1rem' }}></i>
                          {this.state.errorLogin}
                        </span>
                      </div>
                    )}

                  <MDBInput
                    label="Número de DNI"
                    icon="user"
                    group
                    validate
                    error="wrong"
                    success="right"
                    value={this.state.username}
                    onChange={this.onChange.bind(this)}
                    name="username"
                    id="username"
                    type="text"
                  />
                  <div style={{ position: "relative" }}>
                    <MDBInput
                      label="Contraseña"
                      icon="lock"
                      group
                      validate
                      error="wrong"
                      success="right"
                      value={this.state.clave}
                      onChange={this.onChange.bind(this)}
                      name="clave"
                      id="clave"
                      type={this.state.showPassword ? "text" : "password"}
                    />
                    <MDBIcon
                      icon={this.state.showPassword ? "eye-slash" : "eye"}
                      onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#999"
                      }}
                    />
                  </div>

                  <div className="text-right" style={{ marginTop: "-10px", marginBottom: "12px" }}>
                    <a
                      href="/recuperar-contrasena"
                      style={{
                        fontSize: "0.88rem",
                        color: "#7A1622",
                        fontWeight: "500",
                        textDecoration: "none"
                      }}
                      onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                      onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                    >
                      <MDBIcon icon="key" className="mr-1" size="sm" />
                      ¿Olvidaste tu contraseña?
                    </a>
                  </div>

                  <div style={{ border: this.state.errorCaptcha ? '2px solid #e74c3c' : '2px solid transparent', borderRadius: '10px', padding: this.state.errorCaptcha ? '12px' : '0', background: this.state.errorCaptcha ? '#fdecea' : 'transparent', transition: 'all 0.3s ease' }}>
                    <p className="text-muted mb-1" style={{ fontSize: "0.85rem", fontWeight: "500", color: this.state.errorCaptcha ? '#c0392b' : undefined }}>Código de verificación {this.state.errorCaptcha && <i className="fas fa-arrow-down ml-1" style={{ color: '#e74c3c' }}></i>}</p>
                  <div
                    className="text-center py-2 mb-2"
                    style={{
                      backgroundColor: "#f5f5f5",
                      borderRadius: "6px",
                      border: "1px dashed #ccc",
                      userSelect: "none",
                      letterSpacing: "8px"
                    }}
                  >
                    {this.state.capcha.split("").map((char, index) => (
                      <span
                        key={index}
                        style={{
                          fontSize: "1.8rem",
                          fontWeight: "bold",
                          fontFamily: "monospace",
                          color: captchaColors[index % captchaColors.length],
                          display: "inline-block",
                          transform: `rotate(${Math.floor(Math.random() * 20 - 10)}deg)`
                        }}
                      >
                        {char}
                      </span>
                    ))}
                    <MDBIcon
                      icon="sync-alt"
                      className="ml-3"
                      style={{ cursor: "pointer", color: "#999", fontSize: "0.9rem", letterSpacing: "0" }}
                      onClick={this.refreshCaptcha}
                      title="Generar nuevo código"
                    />
                  </div>

                  <MDBInput
                    label="Ingresar código de verificación"
                    icon="shield-alt"
                    group
                    validate
                    error="wrong"
                    success="right"
                    value={this.state.capchaIngresado}
                    onChange={this.onChange.bind(this)}
                    style={{ textTransform: 'uppercase' }}
                    name="capchaIngresado"
                    id="capchaIngresado"
                    type="text"
                  />
                    {this.state.errorCaptcha && (
                      <div style={{ background: '#fdecea', border: '2px solid #e74c3c', borderRadius: '8px', padding: '10px 14px', marginTop: '10px', marginBottom: '5px' }}>
                        <span style={{ color: '#c0392b', fontWeight: '600', fontSize: '0.85rem', display: 'flex', alignItems: 'center' }}>
                          <i className="fas fa-exclamation-triangle mr-2" style={{ fontSize: '1rem' }}></i>
                          {this.state.errorCaptcha}
                        </span>
                      </div>
                    )}
                    </div>

                  <div className="text-center mt-3">
                    <MDBBtn
                      type="submit"
                      style={{ backgroundColor: "#7A1622", borderRadius: "20px" }}
                      className="btn-block"
                    >
                      <MDBIcon icon="sign-in-alt" className="mr-2" />
                      Acceder
                    </MDBBtn>
                  </div>


                </form>
              </MDBCardBody>
            </MDBCard>
            </MDBCol>

          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

export default Login;
